import React, { useCallback, useEffect, useState } from 'react';
import { MainLayoutContext, IMainLayoutContextContext } from './MainLayoutContext';
import { SettingsMenuReactCodes } from '@widgets/MainLayout/interfaces';
import { IconName } from '@etna-trader/etna-ui/dist/components/icon/icon-pack';
import { useOpenIdContext } from '@entities/OpenIDProvider/OpenIdContext';
import { EAuthorization_Features } from '@shared/api';

let ROUTES = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Dashboard',
                path: '/dashboard',
                reactCode: SettingsMenuReactCodes.OperationsDashboardPage,
            },
        ],
        icon: 'Dashboard' as IconName,
    },
    {
        name: `RIA's`,
        path: '/riaListing',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'RIAs',
                path: '/riaListing',
                reactCode: SettingsMenuReactCodes.RIAListingPage,
            },
        ],
        icon: 'RIAs' as IconName,
    },
    {
        name: 'Clearing',
        path: '',
        routeGroups: [
            {
                name: 'Current',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'Lightning' as IconName,
                tabs: [
                    {
                        name: 'Current',
                        path: '/current',
                        reactCode: SettingsMenuReactCodes.Current,
                    },
                ],
            },
            {
                name: 'Audit',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'FileCheck' as IconName,
                tabs: [
                    {
                        name: 'Audit',
                        path: '/audits',
                        reactCode: SettingsMenuReactCodes.Audits,
                    },
                ],
            },
        ],
        routes: null,
        tabs: null,
        icon: null,
    },
    {
        name: 'Broker',
        path: '',
        routeGroups: [
            {
                name: 'Accounts',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'User' as IconName,
                tabs: [
                    {
                        name: 'Accounts',
                        path: '/accounts',
                        reactCode: SettingsMenuReactCodes.Accounts,
                    },
                ],
            },
            {
                name: 'Transactions',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'Transaction' as IconName,
                tabs: [
                    {
                        name: 'Transactions',
                        path: '/transactions',
                        reactCode: SettingsMenuReactCodes.Transactions,
                    },
                ],
            },
            {
                name: 'Positions',
                path: '',
                routeGroups: null,
                icon: 'ChartBubbleRace' as IconName,
                tabs: null,
                routes: [
                    {
                        name: 'Security-level',
                        path: '',
                        routeGroups: null,
                        routes: null,
                        icon: null,
                        tabs: [
                            {
                                name: 'Security Level',
                                path: '/security-level',
                                reactCode: SettingsMenuReactCodes.BrokerLevelPositions,
                            },
                        ],
                    },
                ],
            },
        ],
        routes: null,
        tabs: null,
        icon: null,
    },
    {
        name: 'DTC',
        path: '',
        routeGroups: [
            {
                name: 'MQ Messages',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'Mail' as IconName,
                tabs: [
                    {
                        name: 'MQ Messages',
                        path: '/mq-messages',
                        reactCode: SettingsMenuReactCodes.DTCMessages,
                    },
                ],
            },
            {
                name: 'Securities',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'Check' as IconName,
                tabs: [
                    {
                        name: 'Securities',
                        path: '/securities',
                        reactCode: SettingsMenuReactCodes.Securities,
                    },
                ],
            },
        ],
        routes: null,
        tabs: null,
        icon: null,
    },
    {
        name: 'Funding',
        path: '',
        routeGroups: [
            {
                name: 'Clearing Bank',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'Bank' as IconName,
                tabs: [
                    {
                        name: 'Clearing Bank',
                        path: '/clearing-bank',
                        reactCode: SettingsMenuReactCodes.ClearingBank,
                    },
                ],
            },
            {
                name: 'ACATS',
                path: '',
                routeGroups: null,
                routes: null,
                icon: 'Transaction' as IconName,
                tabs: [
                    {
                        name: 'MQ Messages',
                        path: '/acat-requests',
                        reactCode: SettingsMenuReactCodes.ACATRequests,
                    },
                ],
            },
        ],
        routes: null,
        tabs: null,
        icon: null,
    },
    {
        name: 'Orders',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Orders',
                path: '/orders',
                reactCode: SettingsMenuReactCodes.Orders,
            },
        ],
        icon: 'Ticket' as IconName,
    },
    {
        name: 'User Management',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'UserManagement',
                path: '/user',
                reactCode: SettingsMenuReactCodes.UserManagement,
            },
        ],
        icon: 'User' as IconName,
    },
];

let RIA = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Dashboard',
                path: '/dashboard',
                reactCode: SettingsMenuReactCodes.RIADashboardPage,
            },
        ],
        icon: 'Dashboard' as IconName,
    },
    {
        name: 'Clients',
        path: '/clients',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Clients',
                path: '/clients',
                reactCode: SettingsMenuReactCodes.Clients,
            },
        ],
        icon: 'User' as IconName,
    },
    {
        name: 'Trade Allocations',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Trade Allocations',
                path: '/trade-allocations',
                reactCode: SettingsMenuReactCodes.Orders,
            },
        ],
        icon: 'Ticket' as IconName,
    },
    {
        name: 'Threshold',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Threshold',
                path: '/threshold',
                reactCode: SettingsMenuReactCodes.ThresholdPage,
            },
        ],
        icon: 'Threshold' as IconName,
    },
    {
        name: 'Notification',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Notification',
                path: '/notification',
                reactCode: SettingsMenuReactCodes.RIANotificationPage,
            },
        ],
        icon: 'Bell' as IconName,
    },
];

let Client = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Dashboard',
                path: '/dashboard',
                reactCode: SettingsMenuReactCodes.AccountDetails,
            },
        ],
        icon: 'Dashboard' as IconName,
    },
    {
        name: 'Positions',
        path: '',
        routeGroups: null,
        icon: 'ChartBubbleRace' as IconName,
        routes: null,
        tabs: [
            {
                name: 'Security Level',
                path: '/security-level',
                reactCode: SettingsMenuReactCodes.BrokerLevelPositions,
            },
        ],
    },
    {
        name: 'Documents',
        path: '',
        icon: null,
        tabs: null,
        routeGroups: [
            {
                name: '1099 Form',
                path: '',
                routeGroups: null,
                routes: null,
                tabs: [
                    {
                        name: '1099 Form',
                        path: '/1099-form',
                        reactCode: SettingsMenuReactCodes.Send1099,
                    },
                ],
                icon: 'Calendar' as IconName,
            },
            {
                name: 'Account Statement',
                path: '',
                routeGroups: null,
                routes: null,
                tabs: [
                    {
                        name: 'Account Statement',
                        path: '/account-statement',
                        reactCode: SettingsMenuReactCodes.AccountStatement,
                    },
                ],
                icon: 'Transaction' as IconName,
            },
        ],
    },
    {
        name: 'Preferences',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Preferences',
                path: '/preferences',
                reactCode: SettingsMenuReactCodes.Preferences,
            },
        ],
        icon: 'Preferences' as IconName,
    },
];

let TradeDesk = [
    {
        name: 'Trade Orders',
        path: '',
        routeGroups: null,
        routes: null,
        tabs: [
            {
                name: 'Trade Orders',
                path: '/tradeorders',
                reactCode: SettingsMenuReactCodes.TradeOrderPage,
            },
        ],
        icon: 'Bell' as IconName,
    },
];

export const MainLayoutProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { roles } = useOpenIdContext();

    const [routeGroups, setRouteGroups] = useState<any>(ROUTES);

    // Update routeGroups based on roles
    useEffect(() => {
        if (
            roles?.includes(EAuthorization_Features.RIA) ||
            roles?.includes(EAuthorization_Features.Client) ||
            roles?.includes(EAuthorization_Features.TradeDesk)
        ) {
            if (roles?.includes(EAuthorization_Features.Client)) {
                const userStorage = localStorage.getItem('User');
                let userObject: any = null;
                userObject = JSON.parse(userStorage ? userStorage : '');
                const updatedClient = Client.map((client) => {
                    if (
                        client.name === 'Positions' &&
                        !userObject.permissions.some(
                            (permission: { name: string }) => permission.name === 'CanSeePositions',
                        )
                    ) {
                        return null; // Mark as null to exclude later
                    }
                    if (
                        client.name === 'Documents' &&
                        !userObject.permissions.some((permission: { name: string }) => permission.name === 'CanSee1099')
                    ) {
                        return null; // Mark as null to exclude later
                    }
                    return client;
                }).filter((client) => client !== null); // Remove excluded clients

                setRouteGroups(updatedClient);
            } else {
                if (roles?.includes(EAuthorization_Features.RIA)) {
                    setRouteGroups(RIA); // Update to RIA routes if RIA feature is enabled
                } else {
                    setRouteGroups(TradeDesk);
                }
            }
        } else {
            if (roles?.includes(EAuthorization_Features.ClearingUser)) {
                setRouteGroups(ROUTES); // Otherwise use default ROUTES
            }
        }
    }, [roles]); // Only re-run when roles change

    const [sidebarFixed, setSidebarFixed] = useState<boolean>(true);

    const sideBarToggleClick = useCallback(() => {
        setSidebarFixed((prev) => !prev);
    }, []);

    const [currentPath, setCurrentPath] = useState<string | null>(null);

    const value: IMainLayoutContextContext = {
        routeGroups,
        sidebarFixed,
        sideBarToggleClick,
        currentPath,
        setCurrentPath,
    };

    return <MainLayoutContext.Provider value={value}>{children}</MainLayoutContext.Provider>;
};
